export enum FlowStorageHistoryType {
    CREATED = "created",
    RUN_START = "run_start",
    RUN_END = "run_end",
    SAVE = "save",
    COMPLETED = "completed",
    ERROR = "error",
    MOVED_TO_SERVER = "moved_to_server",
    MOVED_TO_CLIENT = "moved_to_client",
    LOG_MESSAGE = "log message",
}
